import { Button, ButtonGroup, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";
import autobind from "autobind-decorator";
import { arrayMove } from 'core/util/ArrayUtils';
import { IFieldProps } from 'decorator-form';
import { pickBy } from 'lodash';
import * as React from "react";
import { connect } from 'react-redux';
import ComponentRegistry from "react-registry/dist/lib/ComponentRegistry"; // TODO update registry for proper access
import { bindActionCreators } from 'redux';

import { IconNames } from "@blueprintjs/icons";
import TextWidget from "common/form/widgets/TextWidget";
import * as configActions from 'core/actions/configActions';
import PageConfig from "panels/page/PageConfig";
import UrlUtil from "../../../core/util/UrlUtil";
import { FlexJustify } from "../../fragments/Flex";

export interface IPagesFieldProps extends IFieldProps<IMenuPage> {
	actions: any;
	availablePages: IPage[];
}

interface IPage extends PageConfig {
	instance: string;
	editName: string;
	rolesAllowed: string[];
}

export interface IMenuPage {
	instance: string;
	path: string;
}

interface IPagesFieldState {
	selected: IMenuPage;
}

// Define a custom component for handling the root position object
class PagesField extends React.Component<IPagesFieldProps, IPagesFieldState> {

	constructor(props: IPagesFieldProps) {
		super(props);
		this.state = {selected: {path: "", instance: null}};
	}

	@autobind
	public removePage(instance: string) {
		const newChildren = undefined;
		this.props.onChange(newChildren);
	}

	@autobind
	public addPage() {
		const { instance } = this.state.selected;

		if(instance) {
				this.props.onChange(this.state.selected);
		} else {
			alert("No page or duplicate page selected");
		}
	}

	@autobind
	private selectPage(page: IPage) {
		this.setState({selected: {...this.state.selected, instance: page.instance}});
	}

	@autobind
	private onPathChange(path: string) {
		this.setState({selected: {...this.state.selected, path}});
	}

	public render() {
		const { formData } = this.props;
		const { selected } = this.state;


		const page = this.props.availablePages.find((e) => e.instance === formData.instance);

		const pageItem = page ? (
			<div key={formData.instance}>
				<FlexJustify>
					<p>
						<div style={{fontWeight: "bold"}}>{page.label}</div>
						<div>({UrlUtil.getLink(formData.path, page.path)})</div>
						<div>Roles allowed: {page.rolesAllowed ? page.rolesAllowed.join(", ") : "All"}</div>
					</p>
				</FlexJustify>
			</div>
		) : null;

		const PageSelect = Select.ofType<IPage>();

		const selectedPage = selected ? this.props.availablePages.find((p) => p.instance === selected.instance) : {label: "Select page"};

		return(
			<div>
				<h4>Pages</h4>
				{pageItem}

				<h5> Add page:</h5>
				<PageSelect
					items={this.props.availablePages}
					noResults={<MenuItem disabled={true} text="No results." />}
					onItemSelect={this.selectPage}
					itemRenderer={renderPanelItem}

				>
					<Button
						text={selectedPage ? selectedPage.label : "Select page"}
						rightIcon="double-caret-vertical"
					/>
				</PageSelect>

				<TextWidget
					value={selected.path}
					onChange={this.onPathChange}
					readonly={false}
					autofocus={false}
					options={{}}
					placeholder="Path prefix"
				/>

				<Button
					text="Add"
					onClick={() => this.addPage() }
				/>
			</    div >
		);
	}
}

const renderPanelItem: ItemRenderer<IPage> = (item, { handleClick, modifiers }) => {
	return (
		<MenuItem
			active={modifiers.active}
			key={item.path}
			label={item.editName}
			onClick={handleClick}
			text={item.label}
		/>
	);
};

const mapStateToProps = (state, ownProps: IPagesFieldProps): any => {
	const availablePages = Object.entries(state.config.panels).filter(([k, v]: any) =>
		"page" === v.id
	).map(([k, v]) => (
		{instance: k, ...v}
	));

	return {
		availablePages
	};
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect<IPagesFieldProps>(mapStateToProps, mapDispatchToProps)(PagesField);



// WEBPACK FOOTER //
// ./src/common/form/fields/PageField.tsx